import PropTypes from 'prop-types';

const propType = {
  reference: PropTypes.string,
  agencyCommission: PropTypes.number,
  agencyCommissionCurrency: PropTypes.string,
  goodsType: PropTypes.string,
  city: PropTypes.string,
  sellers: PropTypes.arrayOf(PropTypes.string),
  buyers: PropTypes.arrayOf(PropTypes.string),
  agentsSellers: PropTypes.arrayOf(PropTypes.string),
  agentsFinders: PropTypes.arrayOf(PropTypes.string),
  status: PropTypes.string,
  dateAuthenticatedDeedSigned: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dateAuthenticatedDeedPlanned: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dateSignedBeforeContract: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  datePayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const WEELODGE_STATUS = {
  FULL_TREATED: 'full_treated',
  SIGNED_DEED: 'signed_deed',
  PAID: 'paid',
  CANCELED: 'canceled',
  INVOICED: 'invoiced',
  PAYMENT_RECEIVED: 'payment_received',
};

export default { propType };
